module.exports = __webpack_public_path__ + "assets/img/vivium-fysio.a2c2974c.png";